// extracted by mini-css-extract-plugin
module.exports = {"similarObject":"style__similarObject","price":"style__price","similarObjectBlock":"style__similarObjectBlock"};